const initialState = () => ({
  repositories: [],
})

const state = initialState

const getters = {
  repositories: state => state.repositories,
}

const mutations = {
  SET_REPOSITORIES (state, repositories) {
    state.repositories = repositories
  },
  // SET_VHOST_VERSIONS (state, versions) {
  //   state.vhostVersions = versions
  // },
}

const actions = {
  async getHostingSettings ({ dispatch }, _username = null) {
    const data = {
      uapi_module: 'Variables',
      uapi_function: 'get_user_information',
      _username,
    }
    try {
      const { payload } = await dispatch('cpanel_uapi', data, { root: true })

      return payload
    } catch (e) {
      throw e
    }
  },
  async getRepositories ({ dispatch, commit }, _username) {
    const data = {
      uapi_module: 'VersionControl',
      uapi_function: 'retrieve',
      fields: '*',
      _username,
    }
    try {
      const { payload } = await dispatch('cpanel_uapi', data, { root: true })
      commit('SET_REPOSITORIES', payload.data)
    } catch (e) {
      throw e
    }
  },
  async createRepo ({ dispatch }, payload) {
    const data = {
      uapi_module: 'VersionControl',
      uapi_function: 'create',
      ...payload
    }

    try {
      const response = await dispatch('cpanel_uapi', data, { root: true })
      console.log(response)
    } catch (e) {
      throw e
    }
  },
  async deleteRepo ({ dispatch }, payload) {
    const data = {
      uapi_module: 'VersionControl',
      uapi_function: 'delete',
      ...payload
    }

    try {
      await dispatch('cpanel_uapi', data, { root: true })
    } catch (e) {
      throw e
    }
  },

  async editRepo ({ dispatch }, payload) {
    const data = {
      uapi_module: 'VersionControl',
      uapi_function: 'update',
      ...payload
    }

    try {
      await dispatch('cpanel_uapi', data, { root: true })
    } catch (e) {
      throw e
    }
  }
}

export default {
  state,
  getters,
  mutations,
  actions,
  namespaced: true
}
